/* eslint-disable react/prop-types */
import CardViewAnnouncement from "./card-view-admin-announcement";
import GridList from "@/components-library/widgets/grid-list";
import classes from "./announcement-list.module.scss";
import classNames from "classnames";
import * as app from "@/app/app.slice";
import Spinner from "@/components-library/widgets/spinner";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";

function AnnouncementList({ announcements, className, admin, status }) {
  const itemComponent = <CardViewAnnouncement admin={admin} />;
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  if (status !== app.Status.FETCHING) {
    if (announcements?.length) {
      return (
        <div className={classNames(classes.container, className)}>
          <GridList
            columns={isMobile ? 1 : 3}
            items={announcements}
            itemComponent={itemComponent}
          />
        </div>
      );
    } else {
      return (
        <Flex
          align="center"
          direction="column"
          justify="center"
          className={classes.container}
        >
          <Label
            weight="bold"
            tag="h5"
            color="secondary"
            align="start"
            className={classes.title}
          >
            {"Siamo spiacenti, nessun elemento trovato"}
          </Label>
        </Flex>
      );
    }
  } else {
    return <Spinner />;
  }
}

export default AnnouncementList;
